/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum ProviderAccreditationBedsAndEquipmentsAliases {
  FRAGMENT_0 = 'fragment-0',
  FRAGMENT_1 = 'fragment-1',
  LAYOUT_0 = 'layout-0',
  PANEL_0 = 'panel-0',
  PANEL_TITLE = 'panel-title',
  TAB_CONTROL = 'tab-control',
  TAB_WITH_CONTENT_BEDS = 'tab-with-content-beds',
  TAB_WITH_CONTENT_EQUIP = 'tab-with-content-equip',
  TEXT_3 = 'text-3',
}
export { ProviderAccreditationBedsAndEquipmentsAliases };
